// order by order of product category id occurence
export const PRDUCT_CATEGORY_ID_ORDER_GROUPS = [
  123, // No Plastic Shampoo Bars
  3, // Sulphate Free Shampoos
  4, // Silicone Free Conditioners
  5, // Silicone Free Hair Masks
  6 // Hair & Body Cosmetics
]
